<template>
    <el-card>
        <div class="course-content material-index is-always-shadow">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    v-if="$$filterPermission('设置-品牌设置-品牌资料查看')"
                    :label="$t('Setting.Brand_setup')"
                    name="brand"
                    :lazy="true">
                    <brand-list />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('设置-场馆信息-场馆列表查看')"
                    :label="$t('Setting.Store_information')"
                    name="store"
                    :lazy="true"
                    v-once>
                    <store-index />
                </el-tab-pane>

                <el-tab-pane :label="$t('Client.Add.customer_label')" name="third" :lazy="true" v-once>
                    <client-tag />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('设置-其他设置-其他设置')"
                    :label="$t('Setting.other_setting')"
                    name="forth"
                    :lazy="true"
                    v-once>
                    <others-setting />
                </el-tab-pane>

                <el-tab-pane
                    :label="$t('Setting.Integral.title')"
                    name="seven"
                    :lazy="true"
                    v-once>
                    <integral-setting />
                </el-tab-pane>

                <el-tab-pane :label="$t('Setting.Import_record')" name="fifth" :lazy="true" v-once>
                    <import-history />
                </el-tab-pane>

                <el-tab-pane :label="$t('Setting.Export_record')" name="sixth" :lazy="true" v-once>
                    <export-history />
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import ClientTag from '@/components/TableCom/Setting/ClientTag';
import ImportHistory from '@/components/TableCom/Setting/ImportHistory';
import ExportHistory from '@/components/TableCom/Setting/ExportHistory';
import StoreIndex from '@/components/TableCom/Setting/StoreIndex';
import OthersSetting from '@/components/TableCom/Setting/OthersSetting';
import BrandList from '@/components/widget/Setting/BrandList';
import IntegralSetting from '@/components/widget/Setting/IntegralSetting';

export default {
    components: {
        ClientTag,
        ImportHistory,
        ExportHistory,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        StoreIndex,
        OthersSetting,
        BrandList,
        IntegralSetting,
    },
    data() {
        return {
            editableTabs: [
                {
                    name: 'brand',
                    isShow: this.$$filterPermission('设置-品牌设置-品牌资料查看'),
                },
                {
                    name: 'store',
                    isShow: this.$$filterPermission('设置-场馆信息-场馆列表查看'),
                }, {
                    name: 'third',
                    isShow: true,
                }, {
                    name: 'fourth',
                    isShow: this.$$filterPermission('设置-其他设置-其他设置'),
                }, {
                    name: 'seven',
                    isShow: true,
                }, {
                    name: 'fifth',
                    isShow: true,
                }, {
                    name: 'sixth',
                    isShow: true,
                },
            ],
        };
    },
    mixins: [require('../../mixins/CacheQuery').default],
    methods: {
        handleClick(tab, event) {},
    },
};

</script>
